export const arrEnv = ['dev', 'qa', 'uat', 'prod'] as const

export type Env = typeof arrEnv[number]

export interface IVars {
  env: Env
  apiPublic: string
  apiUnite: string
  authUrl: string
  staticPath?: string
}

export const vars: IVars & { all: typeof window.FETCHED_DIALER_ENV_DATA } = {
  get all() {
    return window.FETCHED_DIALER_ENV_DATA
  },

  get env() {
    return this.all?.ENV
  },

  get apiPublic(): string {
    return this.all?.API_PUBLIC
  },

  get apiUnite(): string {
    return this.all?.API_UNITE
  },

  get authUrl(): string {
    return this.all?.AUTH_URL
  },

  get staticPath() {
    return this.all?.STATIC_PATH
  },
}
